import React from 'react';

import NewDefaultCard from '@/modules/content/components/ContentCard/NewDefaultCard';
import { ContentCardTypeEnum } from '@/modules/content/config/cards';

import { useAdaptEvent } from '../../config';
import { EventCardProps } from '../types';

function NewDefaultEventCard(props: EventCardProps) {
  const { className, imageProps, noDescription } = props;
  const event = useAdaptEvent(props.event, ContentCardTypeEnum.Mini);

  return (
    <NewDefaultCard
      baseContent={event}
      className={className}
      imageProps={imageProps}
      noDescription={noDescription}
    />
  );
}

export default NewDefaultEventCard;
